import getItems from './getItems'
import simulateRules from './simulateRules'
import getSimulacion from './getSimulacion'
import getStatusMotor from './getStatusMotor'

export const getItemsService = getItems
export const simulateRulesService = simulateRules
export const getSimulacionService = getSimulacion
export const getStatusMotorService = getStatusMotor
